import React, {useState, useEffect, useRef, useContext} from 'react';
import { translateCol } from "../../../custom/columnI18n";
import { useTranslation } from "react-i18next";

import { useSelector } from 'react-redux';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { TabMenu } from 'primereact/tabmenu';
import { AuthContext } from "../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import CustomDropdown from '../../../custom/customDropdown';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { InputTextarea } from 'primereact/inputtextarea';

const KarticeHome = () => {
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const user = useSelector(state => state.user)
        const [selectedRowIdCard , setSelectedRowIdCard] = useState(null);
        const isSelected = (row) => String(getIdCard(row)) === String(selectedRowIdCard);
        const [vehicleOptions, setVehicleOptions] = useState([])
        const [cardsDB, setCardsOptions] = useState([])
        const [employeeOptions, setEmployeeOptions] = useState([])
        const [izabran, setIzabran] = useState(false)
        const [idCard, setIdCard] = useState(null)
        const [popuni, setPopuni] = useState(false)
        const [globalFilter, setGlobalFilter] = useState(null);
        const [first, setFirst] = useState(0);
        const [tableData, setTableData] = useState(null);
        const [allColumns, setAllColumns] = useState([]);
        const [selectedColumns, setSelectedColumns] = useState([]);
         const [originalColumnOrder, setOriginalColumnOrder] = useState([]);

        const [formSubmitted, setFormSubmitted] = useState(false);
        const getIdCard = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
        ///DATA

         const [formDataCards, setFormDataCards] = useState({
        tipKartice: null,
        id_zaposleni: null,
        id_vozilo: null,
        brojKartice: '',
        datumIzdavanja: null,
        VaziOd: null,
        VaziDo: null,
        pin: null,
        napomena: ''
        });


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_izabrali_karticu_da_bi_popunili_po'),
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/GetCard", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                               
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesno_popunjavanje_podataka_kartice'),
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  const popuniStavke = (apiData) => {

    setFormDataCards({
        tipKartice: apiData[0].tipKartice || null,
        id_zaposleni: apiData[0].id_zaposleni || null,
        id_vozilo: apiData[0].id_vozilo || null,
        brojKartice: apiData[0].brojKartice || '',
        datumIzdavanja: apiData[0].datumIzdavanja ? new Date(apiData[0].datumIzdavanja) : null,
        VaziOd: apiData[0].VaziOd ? new Date(apiData[0].VaziOd) : null,
        VaziDo: apiData[0].VaziDo ? new Date(apiData[0].VaziDo) : null,
        pin: apiData[0].pin || null,
        napomena: apiData[0].napomena || ''
      });
};

   useEffect(()=>{
    if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              }
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/finance/GetCardsAndTypes", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);

                                setCardsOptions(parsedData.CardsTypesDB)
                                setEmployeeOptions(parsedData.EmployeeDB)
                                setVehicleOptions(parsedData.VehicleDB)
                                setTableData(parsedData.CardsDB)


                                 if (parsedData.CardsDB && parsedData.CardsDB.length > 0) {
                                                /* Kolone se skupljaju iz SVIH redova, ne samo iz prvog.
                                                   FOR JSON PATH izostavlja kljuc cija je vrednost NULL, pa
                                                   je kolona (npr. Napomena) nestajala iz cele tabele samo
                                                   zato sto je bas PRVA kartica bila bez nje. Redosled prati
                                                   prvo pojavljivanje, tako da ostaje kao u proceduri. */
                                                const sviKljucevi = [];
                                                parsedData.CardsDB.forEach(red => {
                                                    Object.keys(red || {}).forEach(k => {
                                                        if (!sviKljucevi.includes(k)) sviKljucevi.push(k);
                                                    });
                                                });

                                                const columns = sviKljucevi
                                                    .filter(key => !['ID'].includes(key))
                                                    .map(key => ({
                                                    label: key,
                                                    value: key
                                                    }));


                                                setAllColumns(columns);
                                                setOriginalColumnOrder(sviKljucevi);

                                                // Podrazumevano se prikazuju prvih 10 kolona; ostale se biraju u izborniku.
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                              
    }
      },[formSubmitted])



const resetData = ()=> {
        setFormDataCards({
            tipKartice: null,
            id_zaposleni: null,
            id_vozilo: null,
            brojKartice: '',
            datumIzdavanja: null,
            VaziOd: null,
            VaziDo: null,
            pin: '',
            napomena: ''
        });
}
const handleDeleteFuncCard = () => {
       
            confirmDialog({
            message: "Želite obrisati karticu?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async () => {
  setFormSubmitted(true)
  if (idCard) {
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idCard
          }),
        };

        fetch(process.env.REACT_APP_BACKEND_URL + "/finance/DeleteCard", requestOptions)
          .then(handleErrors)
          .then((data) => {

             toast.current.show({
                severity: "success",
                summary: t('admin.m_uspesna_brisanje_kartice'),
                life: 3000,
                });
                resetData()
                setIdCard(null)
                setSelectedRowIdCard(null)
                setIzabran(false)
                setFormSubmitted(false)   // → okida useEffect reload tabele (skloni obrisanu karticu iz UI)
          })
          .catch((error) => {
            setFormSubmitted(false)
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        setFormSubmitted(false)
        toast.current.show({
            severity: "warn",
            summary: t('admin.m_niste_izabrali_karticu_za_brisanje'),
            life: 3000,
            });
  }


  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 
  
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {
  
              //DATA
                  const hasAnyValueCard = Object.values(formDataCards).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formDataCards,
                        datumIzdavanja: toUtcIso(formDataCards.datumIzdavanja),
                        VaziOd: toUtcIso(formDataCards.VaziOd),
                        VaziDo: toUtcIso(formDataCards.VaziDo)
                        };

                  if(izabran && idCard){
                 if(hasAnyValueCard){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idCard),
                                formDataCards: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/UpdateCard", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                             
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima kartice.' && data[0].message != 'Uspešna izmena!'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima kartice.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                               } else {
                                toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesna_izmena_podataka_kartice'),
                                life: 3000,
                                });
                               
                               }
                                setFormSubmitted(false)
                                
                                setIdCard(null)
                                setSelectedRowIdCard(null)
                                setIzabran(false)
                                resetData()
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_popunili_podatke_kartice'),
                        life: 3000,
                    });
                }
           
           
                } else {
                  if(hasAnyValueCard){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  formDataCards: payload
                              }),
                          };
                          
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/InsertCard", requestOptions)
                              .then(handleErrors)
                              .then((data) => {

                                  if(data) {
                                        if(data.message === 'Nedostaju obavezna polja za unos kartice.'){
                                        toast.current.show({
                                        severity: "error",
                                        summary: "Error",
                                        detail: data.message,
                                        life: 3000,
                                        });
                                        return
                                        } 
                                  }
                                  
                                  resetData()
                                  setFormSubmitted(false)
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: t('admin.m_uspesan_unos_podataka_kartice'),
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: t('admin.m_upozorenje_2'),
                          detail: t('admin.m_niste_popunili_podatke_kartice_za_unos'),
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name in formDataCards) {
        setFormDataCards(prev => ({ ...prev, [name]: value }));
        }
    };
  
  
  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Kartice');
  
      const headers = selectedColumns.map(c => translateCol(t, c));

      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Kartice - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
  const header = (
    <div className="export-buttons fakture-stavke-header">
      <div className="fakture-stavke-radnje">
        <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
        {selectedRowIdCard && (
          <Button type="button" icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFuncCard} data-pr-tooltip={t('common.delete')} />
        )}
      </div>
      <input
        type="search"
        onInput={(e) => setGlobalFilter(e.target.value)}
        placeholder={t('nova.phPretraga')}
        className="p-inputtext p-component"
      />
    </div>
  );

     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const chooseCard = (rowData) => {
        const id = getIdCard(rowData);

        setSelectedRowIdCard((prev) => {
        const next = String(prev) === String(id) ? null : String(id);

        if(next) {
        setIdCard(next)
        popuniRedove(id)
        setIzabran(true) 
        }
        else {
        setIdCard(null)
        resetData()
        setIzabran(false) 
        }

        return next;
    });
    }

     const previewBodyTemplateWork = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseCard(rowData)}
              />
            
        </div>
      );
    };

   return (
       <div style={{marginTop:"1%"}}> 
        <Toast ref={toast} />        

        <ConfirmDialog />
    
            <div className='col-12'>
                          <div className='dnevniceDashboard'>
                             <Card>
                            <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                            <div className="gridLicni">
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="tipKartice">{t('admin.tipKartice')}:</label>
                                          <Dropdown 
                                                id="tipKartice" 
                                                name="tipKartice" 
                                                required
                                                invalid={invalidControl(formDataCards.tipKartice)}
                                                value={formDataCards.tipKartice} 
                                                options={cardsDB || []} 
                                                onChange={handleChange}
                                                placeholder={t('magacin.phTip')}
                                            />
                              </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_zaposleni">{t('admin.nosilacKartice')}:</label>
                                            <CustomDropdown
                                                 id="id_zaposleni" 
                                                 name="id_zaposleni" 
                                                 value={formDataCards.id_zaposleni} 
                                                 options={employeeOptions || []}
                                                 placeholder={t('finansije.izaberiZaposlenog')}
                                                 optionLabel="label"
                                                 onChange={handleChange} />
                              </div>
                               <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_vozilo">{t('ture.voziloDuzi')}:</label>
                                            <CustomDropdown
                                                 id="id_vozilo" 
                                                 name="id_vozilo" 
                                                 value={formDataCards.id_vozilo} 
                                                 options={vehicleOptions || []}
                                                 placeholder={t('nova.phVozilo')}
                                                 optionLabel="label"
                                                 onChange={handleChange} />
                              </div>
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                    <label htmlFor="brojKartice">{t('ture.brojKartice')}:</label>
                                    <InputText 
                                    id="brojKartice" 
                                    name="brojKartice" 
                                    required
                                    invalid={invalidControl(formDataCards.brojKartice)}
                                    value={formDataCards.brojKartice} 
                                    onChange={handleChange}
                                    />
                                </div>
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="datumIzdavanja">{t('admin.datumIzdavanja')}:</label>
                                            <Calendar 
                                                id="datumIzdavanja"
                                                name="datumIzdavanja"
                                                value={formDataCards.datumIzdavanja} 
                                                onChange={handleChange}
                                                showIcon 
                                                dateFormat="dd.mm.yy" 
                                                mask="99.99.9999"
                                                />
                              </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="VaziOd">{t('admin.vaziOdCap')}:</label>
                                            <Calendar 
                                                id="VaziOd"
                                                name="VaziOd"
                                                value={formDataCards.VaziOd} 
                                                onChange={handleChange}
                                                showIcon 
                                                dateFormat="dd.mm.yy" 
                                                mask="99.99.9999"
                                                />
                              </div>
                               <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="VaziDo">{t('admin.vaziDoCap')}:</label>
                                            <Calendar 
                                                id="VaziDo"
                                                name="VaziDo"
                                                value={formDataCards.VaziDo} 
                                                required
                                                invalid={invalidControl(formDataCards.VaziDo)}
                                                onChange={handleChange}
                                                showIcon 
                                                dateFormat="dd.mm.yy" 
                                                mask="99.99.9999"
                                                />
                              </div>
                              <div className="col-12 md:col-6 maxWidthInput" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="pin">{t('admin.pin')}:</label>
                                            <InputText
                                                id="pin"
                                                name="pin"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                value={formDataCards.pin}
                                                required
                                                invalid={invalidControl(formDataCards.pin)}
                                                onChange={handleChange}
                                                />
                              </div>
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column', flex: '0 0 50%',  maxWidth: '100%'}}>
                                    <label htmlFor="napomena">{t('nova.napomena')}:</label>
                                    <InputTextarea 
                                    id="napomena" 
                                    name="napomena" 
                                    value={formDataCards.napomena} 
                                    onChange={handleChange}
                                    />
                                </div>

                            </div>
                            <div className="formUnosZap buttonUnosZap">
                            <button type="submit" onClick={handleFormSubmit} style={{minWidth:"fit-content", marginTop:'2%'}} className="btn btn-success">
                                {izabran ? "SAČUVAJ" : "UNOS"}
                            </button>
                            </div>
                            </form>
                          </Card>
                          <Card>
                               <Tooltip target=".export-buttons>button" position="bottom" />
                                   <DataTable
                                          value={tableData || []}
                                          paginator
                                          rows={10}
                                          first={first}
                                          globalFilter={globalFilter}
                                          onPage={(e) => setFirst(e.first)}
                                          scrollable
                                          header={header}
                                          scrollHeight="50vh"
                                          emptyMessage={t('common.noDataTable')}
                                          resizableColumns
                                          className="turePregledTable stavke-tabela"
                                          columnResizeMode="expand"
                                          rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                        >
                                          {selectedColumns.map((colKey) => {
                                          const colMeta = allColumns.find(col => col.value === colKey);
                                          return (
                                            <Column
                                              key={colKey}
                                              field={colKey}
                                              header={translateCol(t, colMeta?.label || colKey)}
                                              sortable
                                              body={(rowData) => {
                                                if (isButtonColumn(colKey)) {
                                                  return previewBodyTemplateWork(rowData, colKey);
                                                }
                                                return rowData[colKey] || '-';
                                              }}
                                              style={{ minWidth: '150px'}}
                                            />
                                          );
                                        })}
                                    </DataTable>
                          </Card>
                          </div>
            </div>                                

       </div>
)
}

export default KarticeHome;